import { render, staticRenderFns } from "./CambioEstadoSellerCenter.vue?vue&type=template&id=0b898d14&scoped=true"
import script from "./CambioEstadoSellerCenter.vue?vue&type=script&lang=js"
export * from "./CambioEstadoSellerCenter.vue?vue&type=script&lang=js"
import style0 from "./CambioEstadoSellerCenter.vue?vue&type=style&index=0&id=0b898d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b898d14",
  null
  
)

export default component.exports